<template>
  <div class="app">
    {{msg}}
  </div>
</template>

<script>
import qs from "qs"
export default {
  name: "CallbackAddress",
  data(){
    return{
      msg:'邮箱验证中......',
      code:this.getParams('email'),
    }
  },
  methods:{
    getCallBack(){
      let data = {
        code:this.code
      }
      this.axios.post("/user/verifyEmail",qs.stringify(data)).then(res=>{
        if(res.data.code===0){
          this.$message({
            type:'success',
            message:'验证成功，时长稍后会发送到您的帐户,3秒后返回首页'
          })
        }else if(res.data.code===2){
          this.$message({
            type:'error',
            message:'请勿重复验证,3秒后返回首页'
          })
        }else{
          this.$message({
            type:'error',
            message:'错误信息,3秒后返回首页'
          })
        }
        setTimeout(() => {
          this.$router.push({name: 'home'})
        },3000)
      })
    },
    getParams(key){
      // 获取URL地址
      let url = window.location.href;
      let params = url.split('?')[1];
      let paramsObj = {};
      if (params) {
        let paramsArr = params.split('&');
        for (let i = 0; i < paramsArr.length; i++) {
          let param = paramsArr[i].split('=');
          paramsObj[param[0]] = param[1];
        }
      }
      return paramsObj[key];
    }
  },
  mounted() {
    this.getCallBack()
  }
}
</script>

<style scoped>

</style>